"use client";

import { IFormInput, IFormSubmit } from "@template/components/Form";
import { useEffect, useState } from "react";
import { Form } from "@template/components";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import { useRouter } from "@/lib/helpers/hooks/useRouter.ts";

export type DomainNameSearchProps = {
  input?: Omit<IFormInput, "name">;
  submit?: Omit<IFormSubmit, "onSubmit"> & { href?: string };
  href?: string;
};

const DomainNameSearch = ({ input, submit }: DomainNameSearchProps) => {
  const router = useRouter();

  const defaultValue = useTypedSelector((state) => state.domains.search.value);

  const [formValue, setFormValue] = useState({
    search: defaultValue,
  });

  const inputs: IFormInput[] = [
    {
      ...input,
      name: "search",
    },
  ];

  const handleChange = (vals: any) => {
    const { search } = vals;
    const cappedSearch = search?.slice(0, 63);
    setFormValue({
      search: cappedSearch,
    });
  };

  const onSubmit = (values: any) => {
    const { search } = values;

    if (!search) return;

    router.push(`${submit?.href || ""}?search=${search}`, {});
  };

  useEffect(() => {
    setFormValue({
      search: defaultValue,
    });
  }, [defaultValue]);
  return (
    <Form
      value={formValue}
      onChange={handleChange}
      inputs={inputs}
      simple
      submit={{
        ...submit,
        text: submit.children,
        style: {
          width: "fit-content",
          marginLeft: "auto",
        },
        ignoreHref: true,
        onSubmit,
      }}
    />
  );
};

export default DomainNameSearch;
